












































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { orderUsersModule } from '../store/modules/OrderUsers'; // ストアモジュール
import { ITree } from '../store/dto/Organization'; // dto
import { IUsers } from '../store/dto/OrderUsers';
import { KanriConstants } from '../fixed/KanriConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class UserSearch extends ApiAccessBase {
  private treeValue: ITree = {szkCd: '', naibCd: '', level: '', position: ''};
  private treeSelectFlag: boolean = false;
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 検索結果ヘッダの設定
  private headers = [
    {
      text: '削除',
      align: 'center',
      sortable: false,
      value: 'delete',
    },
    {
      text: 'ユーザID',
      align: 'center',
      sortable: true,
      value: 'userId',
    },
    {
      text: 'ユーザ名',
      align: 'center',
      sortable: true,
      value: 'nameKanji',
    },
    {
      text: '有効開始日',
      align: 'center',
      sortable: true,
      value: 'startDate',
    },
    {
      text: '有効終了日',
      align: 'center',
      sortable: true,
      value: 'endDate',
    },
  ];
  // 画面初期化処理
  // component生成時に実行
  private created() {
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['user_search']);
    const path: string = KanriConstants.USER_PATH + '/init/search';

    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
          // 再検索
          if (orderUsersModule.CHECK_RE_SEARCH) {
            this.formData = orderUsersModule.GET_FORM_DATA;
            this.syncFormDataToVariableCols();
            this.searchOrg();
          }
      }
    });
  }
  /**
   * ツリー情報の監視
   * deep: true(ネストされたプロパティも監視する)
   */
  @Watch('treeValue', {deep: true})
  private updateTreeValue(newValue: ITree, oldValue: ITree) {
    this.formData['szkCd'] = newValue.szkCd;
    this.formData['naibCd'] = newValue.naibCd;
    this.treeSelectFlag = true;
  }
  /**
   * 登録画面への遷移
   * (新規追加ボタン押下時時に発火)
   */
  private moveInfo() {
    router.push({ name: 'userInfo' });
  }

  /**
   * ユーザ情報の削除
   * @param szkCd 所属コード
   * @param naibCd 内部ユーザコード
   * @param userId ユーザID
   * (表削除列_削除アイコン押下時に発火)
   */
  private deleteUser(param: IUsers) {
    if (window.confirm(Message.I0001)) {
      orderUsersModule.setUsers(param);
      // APIアクセス
      this.apiAccess(
        KanriConstants.USER_PATH + '/delete' + orderUsersModule.GET_PATH , Constants.API_METHOD_POST, false, null)
      .then((result) => {
        this.hrefElement('userSearch', -50);
        if (result === Constants.API_RESULT_SUCCES) {
          // 結果から削除したデータを削除
          for (const rowIndex of Object.keys(this.resultData)) {
            if (this.resultData[Number(rowIndex)]['userId'] === param.userId) {
              this.resultData.splice(Number(rowIndex), 1);
            }
          }
        } else {
        }
      });
    }
  }

  /**
   * ユーザ情報の編集
   * @param szkCd 所属コード
   * @param naibCd 内部ユーザコード
   * @param userId ユーザID
   * (ユーザ/内部ユーザコード列_編集アイコン押下時に発火)
   */
  private dataTransferInfo(param: IUsers) {
    orderUsersModule.setUsers(param);
    this.apiAccess(KanriConstants.USER_PATH + '/exclusive' + orderUsersModule.GET_PATH, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {

        orderUsersModule.transferToInfo();
        router.push({ name: 'userInfo' });
      } else {
        orderUsersModule.moduleSelectReset();
        this.hrefElement('userSearch', -50);
      }
    });
  }

  /**
   * ユーザ情報の検索
   * (検索ボタン押下時に発火)
   */
  private searchOrg() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.apiAccess(KanriConstants.USER_PATH + '/search', Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        orderUsersModule.setFormData(this.formData);
        // 検索一覧の先頭へジャンプ
        this.hrefElement('searchResults', -130);
      } else {
        // TOPへジャンプ
        this.hrefElement('userSearch', -50);
      }
    });
  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    orderUsersModule.moduleReset();
    router.push({ name: 'userMenu' });
    // router.push(routingControlModule.GET_PREVIOUS);
  }
}
